export default "__VITE_ASSET__85580394__"